import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { InactivityContext } from "../InactivityContext";
import Cards from "./Cards";
import BranchClassWiseSales from "./BranchClassWiseSales";
import BranchClassWiseETS from "./BranchClassWiseETS";
import WeeklySaleschart from "./WeeklySaleschart";

const SEDDashBoard = () => {
  const { userPermissions, webApi, userData } = useUserPermissions();

  const inactivityContext: any = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  const { photo1 }: any = InactivityContext;

  return (
    <div className="page-wrapper">
      <div className="content">
        <>
          {/* Page Header */}

          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">SED Dashboard</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    SED Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2"></div>
              <div className="mb-2"></div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12 d-flex">
              <div
                className="card flex-fill"
                style={{
                  background: "#1c1c1e",
                  border: "none",
                  transition: "background 0.4s ease",
                }}
              >
                <div className="card-body" style={{ position: "relative" }}>
                  <h1 className="text-white mb-1">
                    Welcome {userData?.username.toLowerCase()}
                  </h1>
                  <p className="text-white mb-3">Have a Good day at work</p>

                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      height: "100%",
                      aspectRatio: "56 / 56", // ✅ force 1:1
                      // minWidth: "150px",
                      maxWidth: "45%",
                      overflow: "hidden",
                      pointerEvents: "none",
                    }}
                  >
                    <img
                      src={photo1}
                      alt="User Profile"
                      crossOrigin="anonymous"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",

                        /* clarity */
                        filter:
                          "brightness(1.08) contrast(1.15) saturate(1.15)",

                        /* smooth blend */
                        WebkitMaskImage:
                          "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0.7))",
                        maskImage:
                          "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*  Overall Metrics */}
          <div className="row">
            <Cards />
          </div>

          {/* Weekly Sales Chart */}
          <div className="row pt-4">
            <WeeklySaleschart/>
          </div>


          {/* Branch Wise Class Sales SCTS */}
          <div className="row pt-4">
            <div className="col-md-6 mb-3">
              <BranchClassWiseSales />
            </div>
            {/* Branch Wise Class Sales ETS */}
            <div className="col-md-6 mb-3">
              <BranchClassWiseETS/>
            </div>
          </div>


        </>
      </div>
    </div>
  );
};

export default SEDDashBoard;
